require("../../../fonts/icomoon.font");

import { setLocale } from "yup";

function initYup() {
    setLocale({
        mixed: {
            required: "Required",
            notType(params) {
                switch (params.type) {
                    case "number":
                        return "Please enter valid number";
                    case "string":
                        return "Please enter valid text";
                    default:
                        return "Please enter valid value";
                }
            },
        },
        string: {
            email: "Please enter valid e-mail",
            max: ({ max }: { max: number }) => `The provided text should not exceed ${max} characters.`,
            min: ({ min }: { min: number }) => `Please provide at least ${min} characters.`,
        },
        number: {
            min: ({ min }: { min: number }) => `Value must be greater than or equal ${min}`,
            max: ({ max }: { max: number }) => `Value must be less than or equal ${max}`,
        },
        array: {
            min: ({ min }: { min: number }) => `Please define at least ${min} ${min === 1 ? "element" : "elements"}`,
            max: ({ max }: { max: number }) => `The provided array should not exceed ${max} elements}`,
            length: ({ length }: { length: number }) =>
                `The provided array must be ${length} ${length === 1 ? "element" : "elements"} long`,
        },
    });
}

initYup();
